import { datadogRum } from '@datadog/browser-rum'

if (['production', 'stage'].includes(process.env.DEPLOY_ENV)) {
  initializeDatadogRum()
}

export function getEnvironmentVariable () {
  switch (process.env.DEPLOY_ENV) {
    case 'production':
      return 'max-production'
    case 'stage':
      return 'max-staging'
  }
}

function initializeDatadogRum () {
  const env = getEnvironmentVariable()

  datadogRum.init({
    applicationId: 'cee86723-7550-4879-a1aa-59dc25f715a2',
    clientToken: 'pubf15a3975a6a9aed3df1ee63716edc6ba',
    site: 'datadoghq.com',
    service: 'showroom-web-vuejs',
    env,
    version: process.env.SHA, // Used to identify the deployed version in Datadog.
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input'
  })
}
